<template>
  <div>
    <Upload :action="uploadUrl" type="drag" :on-success="uploadMainPic" :format="['jpg','jpeg','png','gif']" :max-size="5120" :on-format-error="handleFormatError" :show-upload-list="false" :on-exceeded-size="handleMaxSize">
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>Click or drag files here to upload</p>
      </div>
    </Upload>
    <div class="mainImage-container" v-if="mainImage">
      <img class="mainImage" :src="mainImage" alt="">
      <div class="mainImage-upload-cover">
        <Icon type="ios-eye-outline" @click.native="visible = true"></Icon>
        <Icon type="ios-trash-outline" @click.native="handleRemoveMainImg"></Icon>
      </div>
    </div>


    <Modal title="图片预览" v-model="visible">
      <img :src="mainImage" v-if="visible" style="width: 100%">
    </Modal>

  </div>
</template>


<script>
  let urlPrefix = process.env.VUE_APP_URL;
  export default {
    props: ["srcData", "keyNum", "flag"],
    data() {
      return {
        uploadUrl: urlPrefix + "/file/imgUpload?token=" + this.$store.getters.token,
        visible: false,
        mainImage: "",

        isLoadSrc: false,
      }
    },
    methods:{
      uploadMainPic(res) {
        this.mainImage = res.url;
      },

      handleRemoveMainImg() {
        this.mainImage = "";
      },


      handleFormatError(file) {
        this.$Notice.warning({
          title: '该文件格式错误',
          desc: file.name + '格式不正确,请选择png,jpg,jpeg,gif格式'
        });
      },

      handleMaxSize(file) {
        this.$Notice.warning({
          title: '文件大小才超出5M',
          desc: file.name + '文件大小超出5M,请选择5M以下的文件'
        });
      },

      handleView() {
        this.visible = true;
      },
    },
    mounted() {
      if (this.flag) {
        this.uploadUrl= urlPrefix + "/file/imgUpload?token=" + this.$store.getters.token + "&flag=1";
      }
      
    },
    watch: {
      mainImage: function (val) {
        this.$emit("change", val);
      },
      srcData: function (val) {
        if (this.isLoadSrc) return;
        this.isLoadSrc = true;
        this.mainImage = val;
      },
      keyNum: {
        handler: function () {
          this.mainImage = this.srcData;
        },
        immediate: true,
      }

    },
  }
</script>

<style lang="less" scoped>
  .mainImage-container{
    width: 60px;
    height: 60px;
    display: inline-block;
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    position: relative;
    overflow: hidden;
    margin-top: 20px;

    img{
      width: 100%;
      height: 100%;
    }
  }
  .mainImage-upload-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
  }

  .mainImage-container:hover .mainImage-upload-cover{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mainImage-upload-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>